import React from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";

import { HAS_INSIGHTS_FILTER } from "@/modules/pg/shared/planningTable/reducers/filters/stockRequirementsFilters";
import { translate } from "@/modules/shared/IntlProviderWrapper";
import MaterialFilter from "../lineOrderList/filters/MaterialFilter";
import { ConnectedLockLine } from "@/modules/pg/shared/planningTable/lineOrderList/LineFilter";

import type {
    SetStockReqFilterMaterials,
    SetHasInsightsFilter,
    ResetFiltersAction,
} from "@/modules/pg/shared/planningTable/reducers/filters/stockRequirementsFilters";
import type { SetHighlightedOrders } from "@/modules/pg/shared/planningTable/reducers/planningTable";
import type { SetSelectedLineUuidsAction } from "@/modules/pg/shared/planningTable/reducers/filters/filters";
import type { ReportLoadingAction } from "@/modules/pg/shared/planningTable/reducers/report";
import type { ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";
import type { UpdateStockRequirementsHeightAction } from "@/modules/pg/shared/planningTable/reducers/gantt/properties";

type ActionTypes =
    | SetStockReqFilterMaterials
    | UpdateStockRequirementsHeightAction
    | SetHasInsightsFilter
    | ResetFiltersAction
    | ReportLoadingAction
    | SetHighlightedOrders
    | SetSelectedLineUuidsAction;

type OwnProps = {};
type Props = OwnProps & ReduxProps;

class StockRequirementsFilters extends React.Component<Props> {
    getMaterialExternalIds = (): string[] => {
        return [...new Set(...[this.props.stock_requirements.map(sr => sr.material_external_id)])];
    };

    onHasInsights = () => {
        this.props.reduxDispatch({ type: HAS_INSIGHTS_FILTER, data: !this.props.has_insights_filter });
    };

    isFilterDisabled = () => {
        return Boolean(this.props.is_filter_locked || this.props.selected_stock_requirement);
    };

    render() {
        return (
            <div className="planning-table-filters">
                <div className="form-row">
                    <div className="form-group col-12 mb-2">
                        <div className="stock-requirements-filters">
                            <MaterialFilter filter_material_external_ids={this.getMaterialExternalIds()} />
                            {!this.isFilterDisabled() && <ConnectedLockLine />}
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <input
                        type="checkbox"
                        checked={this.props.has_insights_filter}
                        onChange={this.onHasInsights}
                        disabled={this.isFilterDisabled()}
                    />{" "}
                    <label
                        className="mb-0"
                        onClick={this.onHasInsights}
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                    >
                        {translate("common.has_insights", "Has insights")}
                    </label>
                </div>
            </div>
        );
    }
}

const mapState = (state: ReduxState) => {
    const has_insights_filter = state.gantt_chart_stock_requirements_filter.has_insights_filter;
    const stock_requirements = state.gantt_chart_stock_requirements.stock_requirements;
    const lines_orders = state.gantt_chart_lines_orders.lines_orders;
    const filtered_materials = state.gantt_chart_filters.selected_materials;
    const selected_filter_type = state.gantt_chart_filters.selected_filter_type;
    const selected_stock_requirement = state.gantt_chart_stock_requirements_filter.selected_stock_requirement;
    const is_filter_locked = state.gantt_chart_filters.is_filter_locked;

    return {
        has_insights_filter,
        filtered_materials,
        stock_requirements,
        lines_orders,
        selected_filter_type,
        selected_stock_requirement,
        is_filter_locked,
    };
};

const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({ reduxDispatch: dispatch });

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(StockRequirementsFilters);
